import React from "react";
import { ReviewItemB, ReviewStatus } from "ComponentsUI/Reviews";
import { generateTime } from "Services/Time";
import { Link, withRouter } from "react-router-dom";
import emotions from "Helpers/emotions";
import { webpSimpleTransformer, webpTransformer } from "Helpers/ImageManager";
import VisibilitySensor from "react-visibility-sensor";

@withRouter
export default class ReviewItemBContainer extends React.Component {
	static defaultProps = {
		text: "",
	};

	constructor(props) {
		super(props);
		this.state = {
			showButton: !this.props.singleReview ? this.props.text.length > 500 : false,
			wasViewed: false,
		};
	}

	showFullHandler(e) {
		this.setState({
			showButton: false,
		});
		e.stopPropagation();
	}

	onClickHandler(e) {
		e.stopPropagation();
	}

	onClickCommentHandler(e) {
		e.stopPropagation();
	}

	onClickReviewHandler(e) {
		if (!this.props.singleReview) {
			this.props.history.push(this.props.urlToFullReview);
		}
		e.stopPropagation();
	}

	wasViewed(isVisible) {
		if (isVisible && !this.state.wasViewed) {
			this.setState({
				wasViewed: true,
			});
			this.props.markReviewAsViewed(this.props.item.id);
		}
	}

	render() {
		let linkToFullReview = <Link to={this.props.urlToFullReview} />;
		let linkToProvider = <Link to={this.props.urlToProvider} />;
		let props = this.props;
		if (!this.props.stub) {
			props = {
				...this.props,
				proofed: !!props?.item?.real,
				date: generateTime(this.props.date),
				showFullHandler: (e) => this.showFullHandler(e),
				onClickHandler: (e) => this.onClickHandler(e),
				onClickReviewHandler: (e) => this.onClickReviewHandler(e),
				onClickCommentHandler: (e) => this.onClickCommentHandler(e),
				linkToFullReview: linkToFullReview,
				linkToProvider: linkToProvider,
				showButton: this.state.showButton,
				id: this.props.item?.id,
				status: !!this.props.status?.code ? (
					<ReviewStatus code={this.props.status.code} texts={this.props.textConst} />
				) : null,
			};
		}
		return (
			<VisibilitySensor onChange={(visible) => this.wasViewed(visible)}>
				<ReviewItemB
					{...props}
					logo={!!props.type ? emotions[props.type] : ""}
					webpTransformer={webpSimpleTransformer}
				/>
			</VisibilitySensor>
		);
	}
}
